import React, { useState, useEffect } from "react";
import { Modal, Button } from "flowbite-react";
import { AiOutlineLoading } from "react-icons/ai";

const EditTemplateMetaModal = ({
  isOpen,
  onClose,
  onSave,
  name,
  description,
  isNew = false,
}) => {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");

  useEffect(() => {
    setTitle(name || "");
    setDesc(description || "");
  }, [name, description]);

  const handleSave = (e) => {
    e.preventDefault();
    onSave({ name: title, description: desc });
  };

  return (
    <Modal show={isOpen} onClose={onClose} size="md">
      <Modal.Header>
        {isNew === true ? "Create Template" : "Edit Template"}
      </Modal.Header>
      <form onSubmit={handleSave}>
        <Modal.Body className="space-y-4">
          <div>
            <label
              htmlFor="title"
              className="block text-sm font-medium text-gray-700 dark:text-gray-200"
            >
              Title
            </label>
            <input
              id="title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              required
            />
          </div>

          <div>
            <label
              htmlFor="description"
              className="block text-sm font-medium text-gray-700 dark:text-gray-200"
            >
              Description
            </label>
            <textarea
              id="description"
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              rows={3}
              required
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button color="gray" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="purple"
            type="submit"
            processingSpinner={
              <AiOutlineLoading className="h-6 w-6 animate-spin" />
            }
          >
            {isNew === true ? "Create" : "Save"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default EditTemplateMetaModal;
